import axios, { AxiosError } from "axios";
import { body } from "./Empresas";
import { CadastroModelo } from "../interface/ICadastroModelo";
import { ModeloAgendamento } from "../interface/IAgendamento";

class CadastroModeloService {
  private api = axios.create({ baseURL: process.env.REACT_APP_API_MICROSERVICO + '/empresa'});

  private headers(body: body, empresaid?: string) {
    return {
      userToken: String(body.userToken), username: String(body.username), userEmpresa: String(body.userEmpresa),
      ...(empresaid ? { empresaid } : {}),
    };
  }

  getAll = (body: body, companyId: string) => this.request<any>(() => this.api.get('/cadastro-modelo', { headers: this.headers(body, companyId) }));
  getAllAgendamentos = (body: body, companyId: string) => this.request<any>(() => this.api.get('/agendamento-modelo', { headers: this.headers(body, companyId) }));
  createAgendamento = (body: body, agendamento: ModeloAgendamento, companyId: string) => this.request<any>(() => this.api.post('/agendamento-modelo', agendamento, { headers: this.headers(body, companyId) }));
  updateAgendamento = (body: body, id: string, agendamento: ModeloAgendamento, companyId: string) => this.request<any>(() => this.api.patch(`/agendamento-modelo/${id}`, agendamento, { headers: this.headers(body, companyId) }));
  inactivateAgendamento = (body: body, id: string, companyId: string) => this.request<any>(() => this.api.delete(`/agendamento-modelo/${id}`, { headers: this.headers(body, companyId) }));
  getOne = (body: body, id: string, companyId: string) => this.request<any>(() => this.api.get(`/cadastro-modelo/${id}`, { headers: this.headers(body, companyId) }));
  create = (body: body, cadastroModelo: CadastroModelo, companyId: string) => this.request<any>(() => this.api.post('/cadastro-modelo', cadastroModelo, { headers: this.headers(body, companyId) }));
  update = (body: body, id: string, cadastroModelo: CadastroModelo, companyId: string) => this.request<any>(() => this.api.patch(`/cadastro-modelo/${id}`, cadastroModelo, { headers: this.headers(body, companyId) }));
  inactivate = (body: body, id: string, companyId: string) => this.request<any>(() => this.api.delete(`/cadastro-modelo/${id}`, { headers: this.headers(body, companyId) }));

  private async request<T>(operation: () => Promise<{ data: T }>): Promise<T> {
    try {
      return (await operation()).data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) console.error(error.message);
      throw error;
    }
  }
}

export default CadastroModeloService;
